"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryField = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var CategoryField = function (_a) {
    var categoryData = _a.categoryData;
    var categoryImageSrc = categoryData.data.image
        ? (0, react_1.useBreakpointValue)({
            base: categoryData.data.image.m,
            md: categoryData.data.image.l,
        })
        : undefined;
    return (react_2.default.createElement(react_1.Box, { width: "100%", css: categoryData.style, className: "" + (categoryData.class ? categoryData.class : "") },
        react_2.default.createElement(react_1.Link, { href: "/" + categoryData.data.front_path, _hover: { textDecoration: "none" } },
            categoryData.data.image && (react_2.default.createElement(react_1.Box, null,
                react_2.default.createElement(react_1.Img, { mx: "auto", src: categoryImageSrc, alt: categoryData.data.image.alt }))),
            categoryData.data.catchphrase && (react_2.default.createElement(react_1.Box, { mt: "1rem" }, categoryData.data.catchphrase)))));
};
exports.CategoryField = CategoryField;
